<script>
    import user from "../stores/user";
    import R, {LOADER} from "../lib/requests";
    import {nl2br, setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import A from "../lib/Router/A.svelte";

    let email = '';
    let password = '';
    let error = null;
    let showModal = true;
    let showLogin = true;
    let showSuccess = false;

    const login = () => {

        const onSuccess = result => {
            user.setUser(result);
            close();
        }

        const onFailure = err => {
            let inputField = null;

            if (err.code === 'account_not_active') {
                error = "Ο λογαριασμός σας δεν είναι ενεργός!\nΕπικοινωνήστε με την γραμματεία του Π.Κ.Σ. για περισσότερες λεπτομέρειες.";
            } else {
                error = "Το email ή ο κωδικός πρόσβασης που εισάγατε δεν είναι έγκυρα.";
                inputField = 'loginPassword';
            }

            // Alert.warning("Είσοδος Μέλους", error, () => setFocusTo(inputField));
            setFocusTo(inputField);
        };

        error = null;
        R.handle(R.app.login, {email, password}, onSuccess, onFailure, LOADER.POPUP);
    }

    const resetPassword = () => {
        const onSuccess = result => {
            showSuccess = true;
        }

        const onFailure = err => {
            let inputField = null;

            if (err.code) {
                if (err.code === 'not_found') {
                    error = "Δεν βρέθηκε ενεργός λογαριασμός με το email που δηλώσατε!";
                    inputField = 'accountEmail';
                }
                if (err.code === 'account_not_active') {
                    error = "Ο λογαριασμός σας δεν είναι ενεργός!\nΕπικοινωνήστε με την γραμματεία του Π.Κ.Σ. για περισσότερες λεπτομέρειες.";
                }

                if (err.code === 'mailer_error') {
                    error = "Παρουσιάστηκε κάποιο πρόβλημα με την αποστολή του μηνύματος για την ανάκτηση του λογαριασμού σας\nΠροσπαθήστε ξανά αργότερα. ";
                }

                setFocusTo(inputField);
            }
        };

        error = false;
        let data = {
            action: 'reset-password',
            email,
        }

        R.handle(R.action.request, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const toggleView = () => {
        showLogin = !showLogin;
        error = null;
        setFocusTo(showLogin ? 'loginMail' : 'accountEmail');
    }

    const close = (param) => {
        $user.showLogin = false;
        showModal = false;
    }

    setFocusTo('loginMail');
</script>
{#if showModal}
    <Modal title="Είσοδος Μέλους" modalSm on:close="{ close }">
        <div slot="body">
            {#if showLogin}
                <form on:submit|preventDefault|stopPropagation={ login }>
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" class="form-control" id="loginMail" name="email" bind:value="{ email }"
                               required>
                    </div>
                    <div class="form-group">
                        <label>Κωδικός</label>
                        <PasswordControl id="loginPassword" name="password" bind:value="{ password }"/>
                    </div>
                    {#if error}
                        <div class="alert alert-danger small">{@html nl2br(error) }</div>
                    {/if}
                    <div class="row">
                        <div class="col-7 pe-0">
                            <div class="btn btn-link px-0" on:click="{ toggleView }">
                                ξέχασα τον κωδικό μου
                            </div>
                        </div>
                        <div class="col-5 ps-0">
                            <button class="btn btn-primary btn-block">Είσοδος</button>
                        </div>
                    </div>
                </form>
                <hr>
                <div class="text-center mb-2">
                    Είστε μέλος του Π.Κ.Σ. και δεν έχετε λογαριασμό;<br>
                    <A href="/signup" class="btn btn-link fw-bold" on:click={ () => $user.showLogin = false }>
                        δημιουργία λογαριασμού
                    </A>
                </div>
            {:else}
                {#if !showSuccess}
                    <p class="small text-gray">
                        Πληκτρολογήστε το email σας για να λάβετε οδηγίες για την αλλαγή του κωδικού πρόσβασης στον
                        λογαριασμό σας.
                    </p>
                    <form on:submit|preventDefault|stopPropagation={ resetPassword }>
                        <div class="form-group">
                            <input type="email" class="form-control" id="accountEmail" bind:value="{ email }"
                                   placeholder="email" required>
                        </div>
                        {#if error}
                            <div class="alert alert-danger small">{@html nl2br(error) }</div>
                        {/if}
                        <button class="btn btn-primary btn-block">Αποστολή</button>
                    </form>
                    <div class="text-center mt-4 mb-2">
                        <button class="btn btn-link" on:click="{ toggleView }">
                            επιστροφή στην είσοδο
                        </button>
                    </div>
                {:else}
                    <p class="small text-gray">
                        Σας έχει σταλεί μήνυμα στο ηλεκτρονικό σας ταχυδρομείο με οδηγίες για την αλλαγή του κωδικού
                        πρόσβασης του
                        λογαριασμού σας.
                    </p>
                    <p class="small text-gray">
                        Αν δεν βλέπετε το μήνυμα στην αλληλογραφία σας ελέγξτε τον φάκελο <strong>"Ανεπιθύμητα"</strong>.
                    </p>
                {/if}
            {/if}
            <div class="text-center">
                <button class="btn btn-link" on:click="{ () => close() }">
                    κλείσιμο
                </button>
            </div>
        </div>
    </Modal>
{/if}